export default __webpack_public_path__ + "static/2-608c61a6cd42c361f51ed13defb22d14.jpg";